import React from "react";
import moment from "moment-timezone";

import currencyFormatter from "../../../helpers/currencyFormatter";
import formatPaymentType from "../../../helpers/format-payment-type";

const formatDate = (date) => (date ? moment(date).format("M/D/YYYY") : "N/A");

const openL2 = (tripId) =>
  window.open(`/trips/${tripId}?tab=operatorPaymentHistory`, "_blank", "noopener,noreferrer");

const OperatorPaymentsBlock = ({ tripId, trip, readOnly }) => {
  const records = (trip?.operatorPaymentHistory || []).filter((r) => !r.deleted);
  const netPayments = records.reduce((acc, r) => acc + (r.amount || 0), 0);

  return (
    <div className="tv-block tv-operator-payments">
      <div className="tv-block-header">
        <h5 className="tv-block-title">Operator Payments</h5>
        {!readOnly && (
          <div className="tv-block-actions">
            <button
              type="button"
              className="base-button icon-button icon-button-small evo-blue"
              onClick={() => openL2(tripId)}
              title="Add/Edit Payment"
            >
              <span className="material-icons">add_circle</span>
            </button>
          </div>
        )}
      </div>

      <div className="tv-block-body">
        {records.length === 0 ? (
          <div className="tv-empty">No operator payments are available.</div>
        ) : (
          <>
            <table className="tv-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Source</th>
                  <th>Type</th>
                  <th className="text-align-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                {records.map((r, i) => (
                  <tr key={r._id || i}>
                    <td>{formatDate(r.paymentDate)}</td>
                    <td>{formatPaymentType(r.paymentType)}</td>
                    <td>{r.amount >= 0 ? "Received" : "Spent"}</td>
                    <td className="text-align-right font-weight-bold">{currencyFormatter.format(r.amount || 0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="tv-net-payments">
              Net Payments: {currencyFormatter.format(netPayments)}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OperatorPaymentsBlock;
